import { HttpStatusCode } from "axios";
import { ApiRequest } from "../../Handlers/ApiReqest";
import { InterActive } from "../../utilities/ViewModelStructure";
import { ISpecializationLevelResponse } from "../../Interfaces/ResponsesData";
import { Notify } from "../../Handlers/Notifications";
import { GeneralMethods } from "../../Handlers/GeneralMethods";

export class PackagesListsVM extends InterActive{
    private specializations:{id:string , value:string}[] = []
    private levels:{id:string , value:string}[] = []
    private specialization:string  = ''
    private level:string = ''
    private levelSpecializationData:ISpecializationLevelResponse = { id:'' , code:'' , price:'' ,courses:[] }
    private allCourses:{course:{id:string , course: string},visiblity:boolean }[] = []

    public get Specializations():{id:string , value:string}[] { return this.specializations }
    public get Levels():{id:string , value:string}[] { return this.levels }
    public get Specialization():string { return this.specialization }
    public get Level():string{ return this.level }
    public get Id():string { return this.levelSpecializationData.id  }
    public get Code():string { return this.levelSpecializationData.code  }
    public get Price():string { return this.levelSpecializationData.price }
    public get AllCourses():{course:{id:string , course: string},visiblity:boolean }[] { return this.allCourses }
    public get CurrentCourses():{id:string , course : string }[] { return this.levelSpecializationData.courses }

    public set Specializations(value:{id:string , value:string}[] ){ this.specializations = value; this.Specialization = value[0]?.id ; this.update() }
    public set Levels(value:{id:string , value:string}[] ){ this.levels = value;  this.Level = value[0]?.id;this.update() }
    public set Specialization(value:string){ this.specialization = value; if(value)this.load(); this.update() }
    public set Level(value:string){ this.level = value;if(value)this.load() ; this.update() }
    public set Id(value:string){ this.levelSpecializationData.id = value; this.update() }
    public set Code(value:string){if(value.length <= 6){ this.levelSpecializationData.code = GeneralMethods.removeNonAlphanumericCapital(value); } this.update() }
    public set Price(value:string){ this.levelSpecializationData.price = GeneralMethods.removeNonFloatNumeric(value); this.update() }
    public set AllCourses(value:{course:{id:string , course: string},visiblity:boolean}[] ){ this.allCourses = value.map(a=>({course:a.course , visiblity:this.levelSpecializationData.courses.some(x=>x.id===a.course.id)?false:true}))  ; this.update() }
    public set CurrentCourses(value:{id:string , course: string }[] ){ this.levelSpecializationData.courses = value; this.update() }

    public refreshList(){
        this.allCourses = this.allCourses.map(a=>({course:a.course , visiblity:this.levelSpecializationData.courses.some(x=>x.id===a.course.id)?false:true}));
        this.update()
    }

    public load(){
        if(this.specialization && this.level){
            this.loading(
                async()=>{
                    try{
                        const response = await ApiRequest.getLevelSpecializationInfo(this.specialization , this.level)
                        if(response){
                            if(response.status === HttpStatusCode.Ok){
                                if(response.data.status){
                                    if(response.data.data){
                                        this.levelSpecializationData = response.data.data
                                        this.refreshList();
                                        this.update()
                                    }
                                    else Notify({type:'danger' , title:'مشكلة' , body:response.data.messege})
                                }else Notify({type:'danger' , title:'مشكلة' , body:response.data.messege})
                            }else Notify({type:'danger' , title:'مشكلة فى الاتصال' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                        }
                    }catch { Notify({type:'danger' , title:'مشكلة فى الاتصال' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'}) }
                }
            )
        }
    }

    public async addCourse(course:{id:string , course: string }){
        const cur = this.allCourses.find(a=>a.course.id === course.id);
        if(cur)cur.visiblity = false
        this.CurrentCourses.push(course)
        this.update()
        try{
            const response = await ApiRequest.attachCourseToSpecializationLevel(this.levelSpecializationData.id, course.id)
            if(response){
                if(response.status === HttpStatusCode.Ok){
                    if(!response.data.status){
                        Notify({type:'danger' , title:'فشل عملية الاضافة', body:'فشل عملية الاضافة برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
                    }
                }else Notify({type:'danger' , title:'فشل عملية الاضافة', body:'فشل عملية الاضافة برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
            }
        }catch{ Notify({type:'danger' , title:'فشل عملية الاضافة', body:'فشل عملية الاضافة برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'}) }
    }
    public async removeCourse(course:{id:string , course: string }){
        const cur = this.allCourses.find(a=>a.course.id === course.id);
        if(cur)cur.visiblity = true
        this.CurrentCourses = this.CurrentCourses.filter(a=>a.id!=course.id)
        this.update()
        try{
            const response = await ApiRequest.detatchCourseToSpecializationLevel(this.levelSpecializationData.id, course.id)
            if(response){
                if(response.status === HttpStatusCode.Ok){
                    if(!response.data.status){
                        Notify({type:'danger' , title:'فشل عملية الاضافة', body:'فشل عملية الاضافة برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
                    }
                }else Notify({type:'danger' , title:'فشل عملية الاضافة', body:'فشل عملية الاضافة برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
            }
        }catch{ Notify({type:'danger' , title:'فشل عملية الاضافة', body:'فشل عملية الاضافة برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'}) }
    }
    public async changeCode(){
        try{
            const response = await ApiRequest.changeSpecializationLevelCode(this.levelSpecializationData.id, this.levelSpecializationData.code )
            if(response){
                if(response.status === HttpStatusCode.Ok){
                    if(response.data.status){
                        Notify({type:'success' , title:'تمت العملية بنجاح', body:'تم تعديل الكود بنجاح'})
                    }else Notify({type:'danger' , title:'فشل عملية الاضافة', body:'فشل عملية التعديل برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
                }else Notify({type:'danger' , title:'فشل عملية الاضافة', body:'فشل عملية التعديل برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
            }
        }catch{ Notify({type:'danger' , title:'فشل عملية الاضافة', body:'فشل عملية التعديل برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'}) }
    }
    public async changePrice(){
        try{
            const response = await ApiRequest.changeSpecializationLevelPrice(this.levelSpecializationData.id, this.levelSpecializationData.price )
            if(response){
                if(response.status === HttpStatusCode.Ok){
                    if(response.data.status){
                        Notify({type:'success' , title:'تمت العملية بنجاح', body:'تم تعديل السعر بنجاح'})
                    }else Notify({type:'danger' , title:'فشل عملية الاضافة', body:'فشل عملية التعديل برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
                }else Notify({type:'danger' , title:'فشل عملية الاضافة', body:'فشل عملية التعديل برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
            }
        }catch{ Notify({type:'danger' , title:'فشل عملية الاضافة', body:'فشل عملية التعديل برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'}) }
    }
}